// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Note: To be credited for a referral, your friends must complete at least one action.`
};

const de_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Hinweis: Um für eine Empfehlung belohnt zu werden, müssen deine Freunde mindestens eine Aktion durchführen.`
};

const es_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Nota: Para recibir crédito por una referencia, tus amigos deben completar al menos una acción.`
};

const fr_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Note : Pour obtenir des chances bonus, vos amis doivent effectuer au moins une action.`
};

const fi_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Huomio: Jotta saisit hyvityksen suosittelusta, ystäviesi on suoritettava vähintään yksi toiminto.`
};

const hi_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `नोट: रेफरल का क्रेडिट पाने के लिए, आपके दोस्तों को कम से कम एक कार्य पूरा करना होगा।`
};

const ja_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `注意：紹介の認定を受けるには、お友達が少なくとも1つのアクションを完了する必要があります。`
};

const nl_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Opmerking: Om krediet te krijgen voor een verwijzing, moeten je vrienden ten minste één actie voltooien.`
};

const pt_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Nota: Para ser creditado por uma indicação, seus amigos devem completar pelo menos uma ação.`
};

const ro_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Notă: Pentru a fi creditat cu o recomandare, prietenii tăi trebuie să finalizeze cel puțin o acțiune.`
};

const th_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `หมายเหตุ: เพื่อรับเครดิตสำหรับการแนะนำ เพื่อนของคุณต้องทำอย่างน้อยหนึ่งการกระทำให้เสร็จสิ้น`
};

const ur_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `نوٹ: سفارش کا کریڈٹ حاصل کرنے کے لیے، آپ کے دوستوں کو کم از کم ایک عمل مکمل کرنا ضروری ہے۔`
};

const zh_hant1_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `注意：要獲得推薦獎勵，您的朋友必須完成至少一個操作。`
};

const da_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Bemærk: For at få kredit for en henvisning skal dine venner gennemføre mindst én handling.`
};

const it_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Nota: Per essere accreditato per un referral, i tuoi amici devono completare almeno un'azione.`
};

const vn_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Lưu ý: Để được tính điểm giới thiệu, bạn bè của bạn phải hoàn thành ít nhất một hành động.`
};

const ko_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `참고: 추천 크레딧을 받으려면 친구들이 최소 하나의 액션을 완료해야 합니다.`
};

const tr_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Not: Referans kredisi almak için arkadaşlarınızın en az bir eylem tamamlaması gerekir.`
};

const lv_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Piezīme: Lai saņemtu kredītu par atsauci, jūsu draugiem jāpabeidz vismaz viena darbība.`
};

const ar_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `ملاحظة: للحصول على رصيد الإحالة، يجب على أصدقائك إكمال إجراء واحد على الأقل.`
};

const bs_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Napomena: Da biste dobili kredit za preporuku, vaši prijatelji moraju završiti najmanje jednu akciju.`
};

const sl_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Opomba: Da se vam pripiše priporočilo, morajo vaši prijatelji dokončati vsaj eno akcijo.`
};

const id_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Catatan: Untuk dikreditkan sebagai referral, teman Anda harus menyelesaikan setidaknya satu aksi.`
};

const sv_widget_referral_credit_note = /** @type {(inputs: {}) => string} */ () => {
	return `Obs: För att få kredit för en hänvisning måste dina vänner slutföra minst en åtgärd.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_referral_credit_note = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_referral_credit_note(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_referral_credit_note", locale)
	if (locale === "en") return en_widget_referral_credit_note(inputs)
	if (locale === "de") return de_widget_referral_credit_note(inputs)
	if (locale === "es") return es_widget_referral_credit_note(inputs)
	if (locale === "fr") return fr_widget_referral_credit_note(inputs)
	if (locale === "fi") return fi_widget_referral_credit_note(inputs)
	if (locale === "hi") return hi_widget_referral_credit_note(inputs)
	if (locale === "ja") return ja_widget_referral_credit_note(inputs)
	if (locale === "nl") return nl_widget_referral_credit_note(inputs)
	if (locale === "pt") return pt_widget_referral_credit_note(inputs)
	if (locale === "ro") return ro_widget_referral_credit_note(inputs)
	if (locale === "th") return th_widget_referral_credit_note(inputs)
	if (locale === "ur") return ur_widget_referral_credit_note(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_referral_credit_note(inputs)
	if (locale === "da") return da_widget_referral_credit_note(inputs)
	if (locale === "it") return it_widget_referral_credit_note(inputs)
	if (locale === "vn") return vn_widget_referral_credit_note(inputs)
	if (locale === "ko") return ko_widget_referral_credit_note(inputs)
	if (locale === "tr") return tr_widget_referral_credit_note(inputs)
	if (locale === "lv") return lv_widget_referral_credit_note(inputs)
	if (locale === "ar") return ar_widget_referral_credit_note(inputs)
	if (locale === "bs") return bs_widget_referral_credit_note(inputs)
	if (locale === "sl") return sl_widget_referral_credit_note(inputs)
	if (locale === "id") return id_widget_referral_credit_note(inputs)
	if (locale === "sv") return sv_widget_referral_credit_note(inputs)
	return "widget_referral_credit_note"
};